import React, { useState } from "react";
import { useHistory } from "react-router";
import { showToast } from "../../Infrastructure/Notifications/ToastrConfig";
import {
  previewUsersCsvAsync,
  uploadUsersCsvAsync,
} from "../../Services/ClientService";
import Card from "../../Shared/Components/Card/Card";
import PrimaryButton from "../../Shared/Components/PrimaryButton/PrimaryButton";
import Table from "../../Shared/Components/Table";
import Header from "./../../Shared/Components/Header/Header";
import { useAuthState } from "../../Services/AuthService";

const UploadLearners = () => {
  const [file, setFile] = useState(null);
  const [goodRows, setGoodRows] = useState([]);
  const [badRows, setBadRows] = useState([]);
  const [uploaded, setUploaded] = useState(false);
  const history = useHistory();
  const [uploading, setUploading] = useState(false);
  const auth = useAuthState();

  const downloadTemplate = () => {
    const csvContent = "email,firstName,lastName\nuser@example.com,John,Doe\n";
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "learners_template.csv";
    link.click();
    window.URL.revokeObjectURL(url);
  };

  const handleFileChange = async (evt) => {
    const selectedFile = evt.target.files[0];
    if (!selectedFile) {
      return;
    }

    setFile(selectedFile);

    try {
      let form = new FormData();
      form.append("csvFile", selectedFile);
      let response = await previewUsersCsvAsync(form);
      setGoodRows(response.goodRows || []);
      setBadRows(response.badRows || []);
      setUploaded(true);

      if (
        !response.success &&
        (!response.goodRows || response.goodRows.length === 0)
      ) {
        showToast(
          false,
          "Failed to read CSV file. Check the headers and file format.",
        );
      }
    } catch {
      setGoodRows([]);
      setBadRows([]);
      setUploaded(false);
      showToast(
        false,
        "Failed to read CSV file. Check the headers and file format.",
      );
    }
  };

  const uploadUsers = async () => {
    setUploading(true);
    let data = {
      users: goodRows,
      clientId: auth.user?.clientId,
    };

    try {
      let response = await uploadUsersCsvAsync(data);
      if (response.success) {
        showToast(true, "Users uploaded");
        history.push("/manage-learners");
      } else {
        showToast(
          false,
          response.errors?.[0]?.error || "Users could not be uploaded",
        );
        setUploading(false);
      }
    } catch {
      showToast(false, "Users could not be uploaded");
      setUploading(false);
    }
  };

  const headings = () => {
    return (
      <>
        <th>First name</th>
        <th>Last name</th>
        <th>Email</th>
      </>
    );
  };

  const goodRowData = () => {
    return (
      <>
        {goodRows.map((l, i) => (
          <tr key={i}>
            <td>{l.firstName}</td>
            <td>{l.lastName}</td>
            <td>{l.email}</td>
          </tr>
        ))}
      </>
    );
  };

  const badRowData = () => {
    return (
      <>
        {badRows.map((l, i) => (
          <tr key={i}>
            <td>{l.firstName}</td>
            <td>{l.lastName}</td>
            <td>{l.email}</td>
          </tr>
        ))}
      </>
    );
  };

  return (
    <>
      <Header
        heading="Upload Learners"
        subheading="Vitae elementum curabitur vitae nunc sed"
        icon="upload"
      />
      <div className="container-fluid content">
        <div className="row">
          <div className="col-12">
            <Card title="Choose CSV">
              <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                <p className="mb-2">
                  Download a template if you need the correct CSV format.
                </p>
                <button
                  type="button"
                  className="btn btn-outline-success mb-2"
                  onClick={downloadTemplate}
                >
                  Download template
                </button>
              </div>
              <div className="form-group">
                <div className="custom-file">
                  <input
                    accept=".csv,text/csv"
                    className="custom-file-input"
                    type="file"
                    onChange={handleFileChange}
                  />
                  <label className="custom-file-label">
                    {file && file.name}
                  </label>
                </div>
              </div>
              {uploaded && (
                <p>
                  {goodRows.length} users will be uploaded. {badRows.length}{" "}
                  users were invalid
                </p>
              )}
            </Card>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            {goodRows.length > 0 && (
              <Card title="The following users will be uploaded">
                <Table headings={headings} rowData={goodRowData} />
                {uploading && <p>Uploading, please wait</p>}
                <PrimaryButton
                  text="Upload users"
                  func={uploadUsers}
                  classes="float-right mt-3"
                />
              </Card>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            {badRows.length > 0 && (
              <Card title="The following users already exist, or the rows contained errors">
                <Table headings={headings} rowData={badRowData} />
              </Card>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UploadLearners;
